import React from "react";
import { Graphics } from "@pixi/react";

/**
 * Backport Scrollbar - Theme-styled scrollbar
 * - Track: theme blue with opacity
 * - Thumb: yellow accent color
 * - Square corners (no border radius)
 */
const TRACK_COLOR = 0x0d1654;
const TRACK_ALPHA = 0.8;
const THUMB_COLOR = 0xffbf11;

const Scrollbar = ({ scrollY, maxScrollY, viewportHeight, x, y, width = 8 }) => {
  if (maxScrollY <= 0) return null;

  const scrollbarWidth = width;
  const scrollbarHeight = viewportHeight;

  // Calculate thumb size and position
  const contentRatio = viewportHeight / (viewportHeight + maxScrollY);
  const thumbHeight = Math.max(scrollbarHeight * contentRatio, scrollbarWidth * 3);
  const scrollRatio = scrollY / maxScrollY;
  const thumbY = (scrollbarHeight - thumbHeight) * scrollRatio;

  return (
    <Graphics
      x={x}
      y={y}
      draw={(g) => {
        g.clear();

        // Track — theme blue, semi-transparent, square
        g.beginFill(TRACK_COLOR, TRACK_ALPHA);
        g.drawRect(0, 0, scrollbarWidth, scrollbarHeight);
        g.endFill();

        // Thumb — yellow accent, square
        g.beginFill(THUMB_COLOR, 1);
        g.drawRect(0, thumbY, scrollbarWidth, thumbHeight);
        g.endFill();
      }}
    />
  );
};

export default Scrollbar;
